<tr *ngIf="!featureNewEditionsUXDesign">
  <td *ngIf="isExpandable">
    <button
      *ngIf="edition.hasItems"
      class="panel-expansion-button"
      data-automation-id="expand-loc-info"
      [attr.aria-label]="'epanCollapseEditionPanel' | translate"
      [attr.aria-expanded]="edition.availability?.expanded"
      (click)="toggleEdition(edition)">
      <fa-icon class="arrow-icon" [icon]="edition.availability?.expanded ? arrowIconUp : arrowIconDown"></fa-icon>
    </button>
  </td>
  <td data-automation-id="publication-date-cell">{{ edition.publicationDate || '—' }}</td>
  <td data-automation-id="edition-cell">{{ edition.edition || '—' }}</td>
  <td data-automation-id="details-cell">
    <button
      class="ins-buttons button-primary details"
      data-automation-id="details-popup-button"
      [tippy]="'showDetailsPopup' | translate"
      [attr.aria-label]="'showDetailsPopup' | translate"
      (click)="showDetails(edition)">
      <fa-icon class="info-icon" [icon]="infoCircle"></fa-icon>
    </button>
  </td>
  <td data-automation-id="publisher-cell">{{ edition.publisher || '—' }}</td>
  <td data-automation-id="description-cell">
    <ng-container *ngIf="!edition.physicalDescription; else description">
      <span> — </span>
    </ng-container>
    <ng-template #description>
      {{ edition?.physicalDescription }}
    </ng-template>
  </td>
  <td data-automation-id="actions-cell">
    <ng-container *ngIf="loading; else showData">
      --
    </ng-container>
    <ng-template #showData>
      <ng-container *ngIf="!isPatronAuthorized; else authorized">
        <button
          class="ins-buttons no-border button-primary flint w-100"
          data-automation-id="place-hold-btn"
          translate
          (click)="onGetIt($event)"
          [attr.aria-describedby]="'get-offers-button'"
        >
          {{'request' | translate}}
        </button>
      </ng-container>
      <ng-template #authorized>
        <ng-container *ngIf="offer; else error">
          <button
            class="ins-buttons no-border button-primary flint w-100"
            data-automation-id="place-hold-btn"
            translate
            (click)="onGetIt($event)"
            [attr.aria-describedby]="'get-offers-button'"
          >
            {{'request' | translate}}
          </button>
        </ng-container>

        <ng-template #error>
          <div class="offers-box offeraunvailable">
            <div class="data-box">
              <p class="text bold">Get a physical copy</p>
              <p class="text">This resource is currently unavailable</p>
            </div>
          </div>
        </ng-template>
      </ng-template>
    </ng-template>
  </td>
</tr>
<div *ngIf="featureNewEditionsUXDesign" class="list-container">
    <div class="list-item-container">
      <div class="list-item">
        <div *ngIf="isExpandable && !isElectronic">
          <button
            *ngIf="edition.hasItems"
            class="panel-expansion-button"
            data-automation-id="expand-loc-info"
            [attr.aria-label]="'epanCollapseEditionPanel' | translate"
            [attr.aria-expanded]="edition.availability?.expanded"
            (click)="toggleEdition(edition)"
          >
            <fa-icon
              class="arrow-icon"
              [icon]="
                edition.availability?.expanded ? arrowIconUp : arrowIconDown
              "
            ></fa-icon>
          </button>
        </div>
        <div>
          <div class="thumbnail-container">
            <img
              class="thumbnail-container-image"
              src="{{ edition?.coverUrl?.small }}"
              alt="cover"
              *ngIf="edition?.coverUrl?.small"
            />
            <app-cover
              *ngIf="!edition?.coverUrl?.small"
              [title]="edition.publisher"
              [materialType]="edition.type"
              data-automation-id="full-card-image"
              size="small"
            ></app-cover>
            <button
              class="list-item__button button-primary details"
              data-automation-id="details-popup-button"
              [tippy]="'showDetailsPopup' | translate"
              [attr.aria-label]="'showDetailsPopup' | translate"
              (click)="showDetails(edition)"
            >
              <span translate>itemDetails</span>
              <fa-icon class="list-item__info-icon" [icon]="infoCircle"></fa-icon>
            </button>
          </div>
        </div>
        <div class="list-item__cell">
          <div class="d-flex flex-column">
            <div class="list-item__title" translate>publicationDateTitle</div>
            <div>{{ edition.publicationDate || "—" }}</div>
          </div>
          <div class="list-item__divider"></div>
        </div>
        <div class="list-item__cell">
          <div class="d-flex flex-column">
            <div class="list-item__title" translate>editionTitle</div>
            <div>{{ edition.edition || "—" }}</div>
          </div>
          <div class="list-item__divider"></div>
        </div>
        <div *ngIf="!isElectronic" class="list-item__cell">
          <div class="d-flex flex-column">
            <div class="list-item__title" translate>publisherTitle</div>
            <div>{{ edition.publisher || "—" }}</div>
          </div>
          <div class="list-item__divider"></div>
        </div>
        <div *ngIf="isElectronic" class="list-item__cell">
          <div class="d-flex flex-column">
            <div class="list-item__title" translate>vendorTitle</div>
            <div>{{ edition.vendor || "—" }}</div>
          </div>
          <div class="list-item__divider"></div>
        </div>
        <div *ngIf="!isElectronic" class="list-item__cell">
          <div class="d-flex flex-column">
            <div class="list-item__title" translate>
              physicalDescriptionTitle
            </div>
            <div data-automation-id="description-cell" *ngIf="!isElectronic">
              <ng-container
                *ngIf="!edition.physicalDescription; else description"
              >
                <span> — </span>
              </ng-container>
              <ng-template #description>
                {{ edition?.physicalDescription }}
              </ng-template>
            </div>
          </div>
          <div class="list-item__divider"></div>
        </div>
        <div data-automation-id="note-cell" *ngIf="isElectronic">
          <span
            *ngIf="edition.publicNote; else emptyNote"
            data-automation-id="public-note-link"
            class="resource-url"
            (click)="onOpenPublicNoteLink(edition)"
          >
            {{ edition.publicNote }}
          </span>
          <ng-template #emptyNote>—</ng-template>
        </div>
        <div>
          <app-toolbar-buttons
            *ngIf="!edition.isGetItSuppressed"
            [label]="label"
            [tabName]="tabName"
            [isElectronicResource]="edition.type == editionType?.ELECTRONIC"
            [resourceId]="fgId"
            [availability]="
              availabilityUpdates && availabilityUpdates[idx]?.status
            "
            [reserve]="availabilityUpdates && availabilityUpdates[idx]?.reserve"
            [eVendorAvailabilityPending]="
              availabilityUpdates &&
              availabilityUpdates[idx]?.eVendorAvailabilityPending
            "
            [instanceId]="edition.id"
            [hasEcontentIssues]="hasEditionEcontentIssues"
            [recordId]="[edition.recordId]"
            [eResourceUrls]="edition.eResourceUrls"
            (getIt$)="getIt$.emit($event)"
            (placeHold$)="placeHold$.emit($event)"
            [type]="'secondary'"
            [getOneEdition]="true"
          >
          </app-toolbar-buttons>
        </div>
      </div>
      <div class="location-information-row location-information">
        <div
          class="panel-content"
          [ngClass]="{
            'panel-content-expanded d-flex overflow-auto':
              edition.availability?.expanded
          }"
          [attr.colspan]="displayedColumns?.length"
        >
          <div *ngIf="edition.availability?.loading" class="list-item__loading-container">
            <div
              class="spinner-border text-primary location-info-spinner"
              role="status"
              aria-live="polite"
            >
              <span class="sr-only" translate> Loading... </span>
            </div>
          </div>
          <app-location-table-rapido
            [itemTitle]="itemTitle"
            [tableItems]="edition.availability?.items ?? []"
            *ngIf="!edition.availability?.loading"
          >
          </app-location-table-rapido>
        </div>
      </div>
    </div>
</div>
